///
/// import DOM helpers
///
import DomHelper from "./dom/index";
import Validator from "./validator/index";
import Now from "./now/index";
import UUID from "./uuid/index";
import File from "./file/index";
import Cookie from "./cookie/index";

const Helper = {
  ///
  /// export DOM helpers
  ///

  DomHelper,
  Validator,
  Now,
  UUID,
  File,
  Cookie
};

export default Helper;
